<template>
  <b-modal
    ref="modalChecklistPacote"
    size="xl"
    hide-footer
    no-close-on-backdrop
    :dialog-class="'alteracao-tamanho'"
    :modal-class="'center-modal'"
    @hidden="pacoteEscolhido = null"
  >
    <b-row v-if="false">
      <b-col cols="12">
        <div style="display: flex;justify-content: space-between;">
          <div v-if="mostrarContratantes()">
            <span style="margin-right: 0.5rem;">Contratante(s):</span>
            <div style="display: contents;">
              <b-badge
                v-for="(value, $index) in valueInner.itemChecklistPropostas[valueInner.itemChecklistPropostas.length - 1].listaRespostas"
                :key="$index"
                v-b-tooltip.hover
                :title="`${value.replaceAll(',', ' - ')}`"
                variant="none"
                class="tag-contratantes"
              >
                {{ value.length > 18 ? `${value.replace(',', ' - ').substring(0, 28)}...` : value }}
              </b-badge>
            </div>
          </div>
          <h6 v-if="valueInner && tabFocus === 1">
            N° {{ valueInner.numeroProposta }}</h6>
        </div>
      </b-col>
    </b-row>
    <b-tabs
      v-model="tabFocus"
      lazy
    >
      <b-tab
        v-if="valueInner"
        no-body
        title="Checklist"
      >
        <b-row>
          <b-col cols="12">
            <divisoria-descricao
              :show-titulo="false"
              :titulo="''"
              :descricao="'Através do preenchimento do checklist o gerente conseguirá gerar uma proposta customizada de acordo com o perfil de sua empresa.'"
            />
          </b-col>
        </b-row>

        <b-row
          v-if="valueInner.responsavelAResponder == 'pessoaresponsavel'"
          class="mb-50"
        >
          <b-col cols="12">
            <div
              v-if="valueInner.tipoProposta === 'constituicao'"
              class="aviso"
            >
              Por gentileza, nos informe se a proposta será para Matriz ou Filial, qual a tributação e atividade preponderante!
            </div>
            <div
              v-else
              class="aviso"
            >
              Por gentileza, nos informe o CNPJ, tributação e atividade para geração do checklist customizado!
            </div>
          </b-col>
        </b-row>

        <validation-observer ref="validacaoChecklist">
          <div
            v-if="valueInner.tipoProposta === 'transferencia' && valueInner.itemChecklistPropostas"
            class="corner-checklist"
          >
            <div
              v-for="(checklist, $index) in valueInner.itemChecklistPropostas.filter(fil => fil.tipoRegra === 'tags')"
              :key="$index"
            >
              <b-row>
                <b-col cols="12">
                  <div style="display: flex;align-items: baseline;">
                    <div class="circle">
                      1
                    </div>
                    <span>{{ checklist.descricao }}</span><span
                      v-if="checklist.obrigatorioRegra"
                      style="color: red;margin-left: 0.3rem;"
                    >* </span>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-50">
                <b-col cols="12">
                  <span style="font-size: 11px;">{{ checklist.complementoRegra }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <validation-provider
                    #default="{ errors }"
                    :rules="checklist.obrigatorioRegra ? 'required' : ''"
                    name="Preenchimento obrigatório"
                    :vid="'1'"
                  >
                    <multi-cnpj-input
                      ref="multiCnpjInput"
                      v-model="checklist.listaRespostas"
                      input-style="width: 30%;"
                      :disabled="desabilitar"
                      :externo="true"
                      @atualizar-cnpjs="atualizarCnpjsEmpresaTipo"
                    />
                    <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
                  </validation-provider>
                </b-col>
              </b-row>
            </div>
          </div>

          <div class="corner-checklist">
            <b-row>
              <b-col>
                <validation-provider
                  #default="{ errors }"
                  :rules="'required'"
                  name="Filial"
                >
                  <div style="display: flex;align-items: baseline;margin-bottom: 0.5rem;">
                    <div class="circle">
                      {{ valueInner.tipoProposta === 'transferencia' ? '2' : '1' }}
                    </div>
                    <span> Qual o tipo?</span>
                    <span
                      style="color: red;margin-left: 0.3rem;"
                    >* </span>
                  </div>
                  <b-select
                    v-model="valueInner.tipoEmpresa"
                    :options="optionsFilial()"
                    :disabled="valueInner.tipoProposta === 'transferencia' || desabilitar"
                    @input="carregarTributacoes"
                  />
                  <small class="text-danger">{{ mostrarErro( errors[0]) }}</small>
                </validation-provider>
              </b-col>
              <b-col>
                <validation-provider
                  #default="{ errors }"
                  :rules="'required'"
                  name="Tributação"
                >
                  <div style="margin-top: 0.3rem;margin-bottom: 0.55rem;">
                    <span>Qual a tributação?</span>
                    <span
                      style="color: red;margin-left: 0.3rem;"
                    >* </span>
                  </div>
                  <select-base
                    :ref="'tipoTributacao'"
                    v-model="valueInner.tributacao"
                    class="tributacao"
                    :label-select="'nome'"
                    :carregar="carregarTiposTributacaoChecklist"
                    :disabled="desabilitarTributacaoAtividade || desabilitar"
                    @input="alterarPrimeiroAcesso"
                  />
                  <small class="text-danger">{{ mostrarErro( errors[0]) }}</small>
                </validation-provider>
              </b-col>
              <b-col>
                <validation-provider
                  #default="{ errors }"
                  :rules="'required'"
                  name="Atividade"
                >
                  <div style="margin-top: 0.3rem;margin-bottom: 0.55rem;">
                    <span>Qual a atividade preponderante?</span>
                    <span
                      style="color: red;margin-left: 0.3rem;"
                    >* </span>
                  </div>
                  <select-base
                    :ref="'tipoAtividade'"
                    v-model="valueInner.atividade"
                    class="atividade"
                    :label-select="'nome'"
                    :carregar="carregarTipoAtividadeChecklist"
                    :disabled="desabilitarTributacaoAtividade || desabilitar"
                    @input="carregarChecklist"
                  />
                  <small class="text-danger">{{ mostrarErro( errors[0]) }}</small>
                </validation-provider>
              </b-col>
            </b-row>
          </div>

          <b-row v-if="valueInner.itemChecklistPropostas">
            <b-col>
              <checklist
                v-for="(checklist, $index) in valueInner.itemChecklistPropostas.filter(fil => fil.tipoRegra !== 'tags')"
                ref="checklist"
                :key="$index"
                :value="checklist"
                :desabilitar="desabilitar"
                :proposta-id="valueInner.propostaIdVinculada"
                :gerado-proposta="valueInner.geradoProposta"
                :grupo="grupo + ($index === 0 ? $index : ($index - 1))"
              />
            </b-col>
          </b-row>

          <b-row v-if="valueInner.itemChecklistPropostas && valueInner.itemChecklistPropostas.length > 0">
            <b-col>
              <span style="font-size: 12px;"><span style="color: red;">*</span> Campos com preenchimento obrigatório!</span>
            </b-col>
          </b-row>
        </validation-observer>

        <b-row class="mt-3">
          <b-col cols="12">
            <div style="display: flex;justify-content: flex-end;">
              <b-button
                v-if="valueInner.responsavelAResponder != 'gerenteresponsavel'"
                size="sm"
                variant="primary"
                class="mr-50"
                :disabled="desabilitarBotao()"
                @click="salvarChecklist"
              >
                Salvar
              </b-button>
              <b-button
                v-if="valueInner.responsavelAResponder != 'gerenteresponsavel'"
                size="sm"
                variant="primary"
                class="mr-50"
                :disabled="desabilitarBotao()"
                @click="enviarChecklist"
              >
                Enviar checklist para o gerente
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                @click="closeModal(false)"
              >
                Cancelar
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-tab>

      <b-tab
        v-if="valueInner && valueInner.escolhaPacote"
        no-body
        title="Pacote de honorário"
      >
        <b-row>
          <b-col cols="12">
            <divisoria-descricao
              :show-titulo="false"
              :titulo="''"
              :descricao="'Selecione um dos pacotes de honorários contábeis para aprovação da proposta comercial'"
            />
          </b-col>
        </b-row>

        <b-row class="mb-50">
          <b-col cols="12">
            <div class="aviso">
              Dentro das colocações de V.Sa. vimos apresentar nossos pacotes de honorários contábeis para execução dos serviços de contabilidade abaixo relacionados.
            </div>
          </b-col>
        </b-row>
        <b-row v-if="valueInner">
          <b-col cols="12">
            <tabela-pacote-honorario
              v-for="(pacote) in pacotes"
              :key="pacote.id"
              :escolhido="pacoteEscolhido && pacoteEscolhido.id === pacote.id"
              :value="pacote"
              :porcentagem="proposta.porcentagem"
              @escolher-pacote="pacoteEscolhido = $event"
            />
          </b-col>
        </b-row>
        <b-row
          v-if="servicos && servicos.length > 0"
          class="mb-3"
        >
          <b-col cols="12">
            <tabela-bonificacao
              :servicos="servicos"
              :porcentagem="proposta.porcentagem"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            style="
            display: flex;
            justify-content: flex-end;
            word-break: break-all;
          "
          >
            <span
              v-if="!pacoteEscolhido || !pacoteEscolhido.nome"
              style="color: red;"
            >Selecione o pacote que deseja contratar!</span>
            <b-table
              v-else-if="pacoteEscolhido && pacoteEscolhido.nome"
              :items="[]"
              :fields="[
                {
                  key: 'valorTotal',
                  label: 'Valor total',
                  thStyle: 'font-size: 14.5px;',
                },
              ]"
              bordered
              class="tabela-total"
            >
              <template #head(valorTotal)>
                <span>Valor total: {{ totalizador() | converteValor }}</span>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div style="display: flex;justify-content: flex-end;margin-top: 2rem">
              <b-button
                size="sm"
                variant="none"
                class="btn-danger mr-50"
                @click="abrirJustificativa"
              >
                Recusar proposta
              </b-button>
              <b-button
                size="sm"
                variant="none"
                class="btn-primary mr-50"
                @click="confirmarPacote"
              >
                Aprovar proposta
              </b-button>
              <b-button
                size="sm"
                variant="none"
                class="btn-outline-danger mr-50"
                @click="closeModal(false)"
              >
                Cancelar
              </b-button>
            </div>
          </b-col>
        </b-row>
        <justificativa-proposta-modal
          v-if="mostrarJustificativa"
          :proposta-recusada="true"
          @hidden="rejeitarProposta"
          @cancelar="mostrarJustificativa = false"
        />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<style lang="scss">
.circle {
  width: 25px;
  height: 25px;
  line-height: 25px;
  border: 1px solid #5e5873;
  border-radius: 50%;
  text-align: center;
  color: #5e5873;
  display: inline-block;
  margin-right: 0.5rem;
}

.corner-checklist {
  border-radius: 12px;
  border: 1px solid #afafaf79;
  // padding: 20px;
  padding: 15px 20px 15px 20px;
  margin-bottom: 1rem;
}

.aviso {
  text-align: left;
  font-size: 13px;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 1rem;
  border-radius: 0.3rem;
  p{
    margin:0
  }
}

.alteracao-tamanho {
  width: 1000px !important;
}

.center-modal {
  display: flex !important;
  justify-content: center !important;
}

.tributacao .vs--disabled,
.atividade .vs--disabled {
  .vs__selected {
    color: #b8c2cc !important;
  }
}

.tabela-total {
  width: (100% - 75.5%);
  th {
    background-color: #e1e1e1 !important;
  }

  th,
  td {
    padding: 0.5rem 0.2rem;
  }

  .table-hover {
    tr {
      cursor: default !important;
    }
  }
}

.tag-contratantes {
  border: 1px solid var(--primary);
  color: var(--primary);
  margin-right: 0.5rem;
  font-size: 12px;
  font-weight: 400;
  padding: 2px;
}
</style>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'
import apiParametrizacaoChecklist from '@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/services/api'
import apiCadastroProposta from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import apiEmpresa from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'ChecklistPacote',
  components: {
    ValidationObserver,
    ValidationProvider,
    JustificativaPropostaModal: () => import('@/app-modulo/comercial/portal-proposta/shared/components/justificativa-proposta/JustificaProposta.vue'),
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
    Checklist: () => import('@/app-modulo/comercial/portal-proposta/shared/components/checklist-pacote/components/TelaChecklist.vue'),
    TabelaPacoteHonorario: () => import('@/app-modulo/comercial/portal-proposta/shared/components/checklist-pacote/components/tabela-checklist-pacote/TabelaPacoteHonorario.vue'),
    TabelaBonificacao: () => import('@/app-modulo/comercial/portal-proposta/shared/components/checklist-pacote/components/tabela-checklist-bonificacao/TabelaBonificacao.vue'),
    MultiCnpjInput: () => import('@/shared/components/multi-cnpj-input/MultiCnpjInput.vue'),
  },
  props: {
    proposta: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mostrarJustificativa: false,
      justificativa: '',
      pacoteEscolhido: null,
      tabFocus: 0,
      valueInner: null,
      pacotes: [],
      servicos: [],
      grupo: 2,
    }
  },
  computed: {
    desabilitar() {
      return this.valueInner.status === 'rejeitado' || (this.valueInner.dataChecklistRetorno && this.valueInner.dataChecklistRetorno !== '') || this.valueInner.responsavelAResponder === 'gerenteresponsavel' || this.valueInner.copia
    },
    desabilitarTributacaoAtividade() {
      return this.valueInner.tipoEmpresa !== 0 && this.valueInner.tipoEmpresa !== 1 && this.valueInner.tipoEmpresa !== 2
    },
  },
  watch: {
    proposta(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = { ...value }
        this.grupo = this.valueInner.tipoProposta === 'transferencia' ? 3 : 2
        if (this.valueInner && this.valueInner.escolhaPacote) {
          this.tabFocus = 1
        }
        this.carregarPacotes()

        if (this.valueInner.itemChecklistPropostas && !this.valueInner.itemChecklistPropostas.some(som => som.tipoRegra === 'tags') && this.valueInner.tipoProposta === 'transferencia') {
          this.valueInner.itemChecklistPropostas.push({
            id: 0,
            descricao: 'Informe o CNPJ que será transferido!',
            complementoRegra: 'Em caso de Matriz e Filial informe todos os CNPJ(s) que serão transferidos.',
            tipoRegra: 'tags',
            obrigatorioRegra: true,
            order: this.valueInner.itemChecklistPropostas.length + 1,
            listaRespostas: [],
            code: this.getCode(),
          })
        }

        if (this.valueInner.itemChecklistPropostas.length > 1) {
          this.valueInner.itemChecklistPropostas = this.valueInner.itemChecklistPropostas.sort((a, b) => a.order - b.order)
        }
      }
    },
  },
  created() {
    this.valueInner = { ...this.proposta }
    if (this.valueInner && this.valueInner.escolhaPacote) {
      this.tabFocus = 1
    }
  },
  methods: {
    desabilitarBotao() {
      return !this.valueInner.tributacao || !this.valueInner.atividade || (this.valueInner.status === 'rejeitado' || (this.valueInner.dataChecklistRetorno && this.valueInner.dataChecklistRetorno !== '') || this.valueInner.copia)
    },
    mostrarContratantes() {
      return this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas[this.valueInner.itemChecklistPropostas.length - 1]
              && this.valueInner.itemChecklistPropostas[this.valueInner.itemChecklistPropostas.length - 1].tipoRegra === 'tags'
    },
    carregarPacotes() {
      if (this.proposta && this.proposta.id > 0) {
        api.getPacotesEServicos(this.proposta.id)
          .then(payload => {
            const { pacotes, servicos } = payload.data
            this.pacotes = pacotes
            this.servicos = servicos
          })
      }
    },
    carregarTiposTributacaoChecklist() {
      const isFilial = this.valueInner.tipoEmpresa === 1
      return apiParametrizacaoChecklist.getTributacoesCadastradasChecklistFilial(isFilial, this.valueInner.tipoProposta, true)
    },
    carregarTipoAtividadeChecklist() {
      const isFilial = this.valueInner.tipoEmpresa === 1
      return apiParametrizacaoChecklist.getAtividadesCadastradasChecklist(this.valueInner.tributacao ? this.valueInner.tributacao.id : 0, isFilial, this.valueInner.tipoProposta, true)
    },
    carregarTributacoes() {
      if (this.valueInner.tipoProposta === 'constituicao') {
        if (this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas.length > 0) {
          this.valueInner.alterouChecklist = true
        }
        this.valueInner.itemChecklistPropostas = this.valueInner.tipoProposta === 'transferencia' ? this.valueInner.itemChecklistPropostas.filter(fil => fil.tipoRegra === 'tags') : []
        this.valueInner.tributacao = null
        this.valueInner.atividade = null
        this.$refs.tipoTributacao.primeiroAcesso = true
      }
    },
    alterarPrimeiroAcesso() {
      if (this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas.length > 0) {
        this.valueInner.alterouChecklist = true
      }
      this.valueInner.itemChecklistPropostas = this.valueInner.tipoProposta === 'transferencia' ? this.valueInner.itemChecklistPropostas.filter(fil => fil.tipoRegra === 'tags') : []
      this.valueInner.atividade = null
      this.$refs.tipoAtividade.primeiroAcesso = true
    },
    carregarChecklist() {
      const isFilial = this.valueInner.tipoEmpresa === null ? null : this.valueInner.tipoEmpresa === 1
      if (this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas.length > 0) {
        this.valueInner.alterouChecklist = true
      }
      // this.valueInner.itemChecklistPropostas = []
      this.valueInner.itemChecklistPropostas = this.valueInner.tipoProposta === 'transferencia' ? this.valueInner.itemChecklistPropostas.filter(fil => fil.tipoRegra === 'tags') : []
      if (isFilial !== null && this.valueInner.tributacao && this.valueInner.atividade) {
        apiParametrizacaoChecklist.getChecklist(isFilial, this.valueInner.tributacao.id, this.valueInner.atividade.id, this.valueInner.tipoProposta, true)
          .then(payload => {
            // this.valueInner.itemChecklistPropostas = payload.data
            this.valueInner.itemChecklistPropostas.push(...payload.data)

            this.valueInner.itemChecklistPropostas.forEach(each => {
              // eslint-disable-next-line no-param-reassign
              each.code = this.getCode()
            })
          })
      }
    },
    getCode() {
      return Date.now().toString(36) + Math.random().toString(36).substring(2)
    },
    confirmarPacote() {
      if (!this.pacoteEscolhido || !this.pacoteEscolhido.nome) {
        this.$erro('Escolha um pacote!')
      } else {
        this.$confirmarHtml('Deseja aprovar a proposta?',
          `<div style="font-size: 14px;padding-top: 10px;">Pacote contratado: <strong>${this.pacoteEscolhido.nome}</strong><br>
           Valor total da proposta: <strong>${this.totalizador().toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></div>`,
          'question', 'danger')
          .then(result => {
            if (result.value) {
              this.$isLoading(true)
              api.confirmarEscolhaPacote(this.valueInner.id, this.pacoteEscolhido)
                .then(payload => {
                  this.$emit('escolha-pacote', payload.data)
                  if (!this.proposta.geraContrato) {
                    apiEmpresa.cadastroEmpresaPropostaPortal(this.valueInner.propostaIdVinculada)
                  }
                  this.$confirmar('Proposta aprovada!', 'Deseja visualizar a proposta comercial em PDF agora?', 'question', 'danger')
                    .then(resultado => {
                      if (resultado.value) {
                        this.$emit('visualizar-pdf', this.valueInner)
                        this.closeModal(true)
                      } else {
                        this.closeModal(true)
                      }
                    })
                })
                .catch(err => {
                  this.closeModal(false)
                  this.$erro(err.response.data.message || err.message)
                  throw err
                })
                .finally(() => {
                  this.$isLoading(false)
                })
            }
          })
      }
    },
    totalizador() {
      let valor = 0
      valor += this.getValorPacote()

      for (let index = 0; index < this.servicos.length; index += 1) {
        valor += this.servicos[index].valorAuditar
        if (!this.proposta.porcentagem) {
          valor += this.servicos[index].acrescimo
          valor -= this.servicos[index].desconto
        } else {
          if (this.servicos[index].acrescimo && this.servicos[index].acrescimo > 0) {
            valor += (valor * (this.servicos[index].acrescimo / 100))
          }

          if (this.servicos[index].desconto && this.servicos[index].desconto > 0) {
            valor -= (valor * (this.servicos[index].desconto / 100))
          }
        }
      }
      return valor
    },
    getValorPacote() {
      let valor = this.pacoteEscolhido.valorPacote
      if (this.valueInner.porcentagem) {
        if (this.pacoteEscolhido.acrescimoPacote && this.pacoteEscolhido.acrescimoPacote > 0) {
          valor += ((valor * this.pacoteEscolhido.acrescimoPacote) / 100)
        }
        if (this.pacoteEscolhido.descontoPacote && this.pacoteEscolhido.descontoPacote > 0) {
          valor -= ((valor * this.pacoteEscolhido.descontoPacote) / 100)
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.pacoteEscolhido.acrescimoPacote) {
          valor += this.pacoteEscolhido.acrescimoPacote
        }
        if (this.pacoteEscolhido.descontoPacote) {
          valor -= this.pacoteEscolhido.descontoPacote
        }
      }
      return valor
    },
    closeModal(aprovada) {
      if (this.valueInner.geraContrato && this.valueInner.tipoProposta !== 'semchecklist' && aprovada) {
        this.valueInner.status = 'aprovada'
        this.$emit('abrir-pre-geracao', this.valueInner)
      }
      this.$refs.modalChecklistPacote.hide()
    },
    closeModalCheck() {
      this.$isLoading(false)
      this.$refs.modalChecklistPacote.hide()
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return 'Campo Obrigatório!'
      }
      return erro
    },
    salvarChecklist(manterAberto) {
      this.$isLoading(true)
      if (this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas.some(som => som.tipoRegra === 'tags') && this.$refs.checklist && this.$refs.checklist[this.$refs.checklist.length - 1]) {
        const result = this.$refs.multiCnpjInput?.cnpjInput
        if (result && result !== '') {
          apiCadastroProposta.buscarRazaoSocialCnpj(result, true)
            .then(payload => {
              this.adicionarDadosCnpjs(payload.data, result)
              this.salvar(manterAberto)
            })
        } else {
          this.salvar(manterAberto)
        }
      } else {
        this.salvar(manterAberto)
      }
    },
    salvar(manterAberto) {
      api.salvarChecklistExterno(this.valueInner)
        .then(payload => {
          payload.data.arquivosNome.forEach(each => {
            const item = each.split(';')
            const file = this.valueInner.itemChecklistPropostas.filter(fil => item[0] === fil.nomeArquivo)
            const formData = this.getFormDataBody(file, { id: item[1], propostaId: this.proposta.propostaIdVinculada })
            this.addAnexoCheckList(formData)
          })
          this.valueInner.itemChecklistPropostas = payload.data.itemChecklistPropostaDetails
          this.$emit('adicionar-check', { propostaId: this.proposta.id, itens: payload.data })
          this.$sucesso('Checklist salvo com sucesso!')
          this.$isLoading(false)
          if (!manterAberto) {
            this.closeModal(false)
          }
        })
        .catch(err => {
          this.$isLoading(false)
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
    adicionarDadosCnpjs(dado, cnpjInput) {
      if (!this.$refs.checklist[this.$refs.checklist.length - 1].$refs.multiCnpjInput.cnpjs.some(f => f.includes(cnpjInput))) {
        this.valueInner.itemChecklistPropostas[this.valueInner.itemChecklistPropostas.length - 1].listaRespostas.push(dado)
        this.$refs.checklist[this.$refs.checklist.length - 1].$refs.multiCnpjInput.cnpjs = this.valueInner.itemChecklistPropostas[this.valueInner.itemChecklistPropostas.length - 1].listaRespostas
        this.$refs.checklist[this.$refs.checklist.length - 1].$refs.multiCnpjInput.cnpjInput = ''
      }
    },
    enviarChecklist() {
      if (this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas.some(som => som.tipoRegra === 'tags') && this.$refs.checklist && this.$refs.checklist[this.$refs.checklist.length - 1]) {
        const result = this.$refs.multiCnpjInput?.cnpjInput
        if (result && result !== '') {
          apiCadastroProposta.buscarRazaoSocialCnpj(result, true)
            .then(payload => {
              this.adicionarDadosCnpjs(payload.data, result)
              this.enviar()
            })
        } else {
          this.enviar()
        }
      } else {
        this.enviar()
      }
    },
    enviar() {
      this.$refs.validacaoChecklist.validate()
        .then(success => {
          if (success) {
            this.$confirmar('Deseja enviar o checklist para o gerente agora?',
              'Após confirmar, será notificado o gerente para dar sequencia na geração dos dados da proposta baseado nos itens respondido nesse checklist.', 'question', 'danger')
              .then(resultado => {
                if (resultado.value) {
                  this.$isLoading(true)
                  this.enviarChecklistEAtualizarPortal()
                } else {
                  this.salvarChecklist(true)
                }
              })
          } else {
            this.$erro('Preencha os campos corretamente!')
          }
        })
    },
    enviarChecklistEAtualizarPortal() {
      api.enviarChecklist(this.valueInner)
        .then(payload => {
          payload.data.arquivosNome.forEach(each => {
            const item = each.split(';')
            const file = this.valueInner.itemChecklistPropostas.filter(fil => item[0] === fil.nomeArquivo)
            const formData = this.getFormDataBody(file, { id: item[1], propostaId: this.proposta.propostaIdVinculada })
            this.addAnexoCheckList(formData)
          })
          this.$sucesso('Checklist enviado ao gerente, em breve você receberá a proposta comercial!')
          // this.$set(this.proposta, 'justificativa', 'Checklist enviado ao gerente, em breve você receberá a proposta comercial!')
          this.$emit('envio-checklist',
            {
              propostaId: this.proposta.id,
              justificativa: 'Checklist enviado ao gerente, em breve você receberá a proposta comercial!',
              itens: payload.data,
            })
          this.closeModalCheck()
        })
    },
    getFormDataBody(fileItem, body) {
      const formData = new window.FormData()
      const file = fileItem[0].arquivoAnexo
      if (file) {
        formData.append('file', file.file, file.filename || file.name)
      }
      formData.append('body', JSON.stringify(body))

      return formData
    },
    addAnexoCheckList(formData) {
      // eslint-disable-next-line global-require
      const axios = require('axios')

      apiCadastroProposta.addAnexoItemCheckList(formData, axios.CancelToken, true)
        .then(() => {
          this.$swal({
            icon: 'success',
            title: 'Sucesso',
            text: 'Anexos salvos com sucesso!',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
        .catch(err => {
          this.$swal({
            icon: 'warning',
            title: 'Erro',
            text: err.response === undefined ? 'Tamanho do arquivo excedeu o limite de 512mb' : err.response.data.message,
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          })
        })
    },
    rejeitarProposta(justificativaRecusar) {
      this.mostrarJustificativa = false
      this.$emit('status-proposta', { proposta: this.proposta, naoAprovar: true, justificativa: justificativaRecusar })
      this.proposta.escolhaPacote = false
      this.proposta.status = 'naoaprovada'
      this.closeModal(false)
    },
    abrirJustificativa() {
      this.pacoteEscolhido = {}
      this.mostrarJustificativa = true
    },
    optionsFilial() {
      if (this.proposta.tipoProposta === 'transferencia') {
        return [{ value: null, text: '' }, { value: 1, text: 'Filial' }, { value: 0, text: 'Matriz' }, { value: 2, text: 'Matriz e Filial' }]
      }
      return [{ value: null, text: '' }, { value: 1, text: 'Filial' }, { value: 0, text: 'Matriz' }]
    },
    atualizarCnpjsEmpresaTipo(value) {
      const antigoTipo = this.valueInner.tipoEmpresa
      const filtro = value.filter(fil => fil.includes('Matriz'))
      const filtroFilial = value.filter(fil => fil.includes('Filial'))
      if (filtro.length > 1) {
        this.$erro('Somente é permitido um CNPJ de Matriz por proposta! Contate nossos analistas para mais informações.')
      } else if (filtroFilial.length === 0 && filtro.length === 1) {
        this.$set(this.valueInner, 'tipoEmpresa', 0)
      } else if (filtroFilial.length > 0 && filtro.length === 0) {
        this.$set(this.valueInner, 'tipoEmpresa', 1)
      } else if (filtro.length > 0 && filtroFilial.length > 0) {
        this.$set(this.valueInner, 'tipoEmpresa', 2)
      }

      if (antigoTipo) {
        if ((this.valueInner.tipoEmpresa === 0 || this.valueInner.tipoEmpresa === 2) && antigoTipo === 1) {
          this.limparDadosChecklist(false)
        } else if (this.valueInner.tipoEmpresa === 1 && (antigoTipo === 0 || antigoTipo === 2)) {
          this.limparDadosChecklist(false)
        }
      }

      if (!value || value.length === 0) {
        this.limparDadosChecklist(true)
      }

      const index = this.valueInner.itemChecklistPropostas.findIndex(where => where.tipoRegra === 'tags')
      if (index > -1) {
        this.valueInner.itemChecklistPropostas[index].listaRespostas = value
      }
    },
    limparDadosChecklist(limparTipoEmpresa) {
      if (limparTipoEmpresa) {
        this.valueInner.tipoEmpresa = null
      }
      this.valueInner.tributacao = null
      this.valueInner.atividade = null
      this.valueInner.itemChecklistPropostas = this.valueInner.itemChecklistPropostas.filter(fil => fil.tipoRegra === 'tags')
      this.$refs.tipoTributacao.primeiroAcesso = true
      this.valueInner.alterouChecklist = true
    },
  },
}
</script>
